export const GET_GRADE_LEVELS = 'GRADE_LEVEL/get_grade_level';
export const SHOW_GRADE_LEVEL = 'GRADE_LEVEL/show_grade_level';
export const CREATE_GRADE_LEVEL = 'GRADE_LEVEL/create_grade_level';
export const UPDATE_GRADE_LEVEL = 'GRADE_LEVEL/update_grade_level';
export const REMOVE_GRADE_LEVEL = 'GRADE_LEVEL/remove_grade_level';

export const FORM_DATA = {
  code: '',
  name: '',
  is_active: 0,
};
